import React from 'react';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { CommandServices } from '@wix/cli-command-contract';
import { toJsonString } from '@wix/cli-fs';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import type { ReleaseCommandProps } from '../components/ReleaseCommand/index.js';
import { ReleaseCommand } from '../components/ReleaseCommand/index.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractiveRelease(
  services: CommandServices,
  model: ProjectModel,
  releaseProps: ReleaseCommandProps
) {
  const { preEnteredComment, preSelectedVersionType } = releaseProps;

  if (!preSelectedVersionType) {
    throw new CliError({
      code: CliErrorCode.InsufficientNonInterractiveReleaseParameters(),
      cause: null,
    });
  }

  const version = await executeCommand<string>(services, model, (resolve) => (
    <ReleaseCommand
      {...releaseProps}
      preEnteredComment={preEnteredComment ?? ''}
      onReleaseDraftCreated={(version) => {
        resolve(version);
      }}
    />
  ));

  log(toJsonString({ version }, { spaces: 2 }).trimEnd());
}
